import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconComponent } from '../icon/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-search-input',
  imports: [IconComponent],
  styleUrl: './search-input.scss',
  templateUrl: './search-input.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchInputComponent),
      multi: true,
    },
  ],
})
export class SearchInputComponent implements ControlValueAccessor {
  /** Texte indicatif. */
  @Input() placeholder = 'Rechercher...';

  /** Libellé accessible. */
  @Input() ariaLabel = 'Rechercher';

  /** Valeur initiale (modèle). */
  @Input() value = '';

  /** Émis à chaque frappe (déjà debouncé côté consommateur si besoin). */
  readonly search = output<string>();

  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.value = value == null ? '' : String(value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  protected onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
    this.search.emit(this.value);
  }

  protected clear(): void {
    this.value = '';
    this.onChange(this.value);
    this.search.emit(this.value);
  }
}
